<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item :label="$t('设备ID')">
              <a-input v-model="model.deviceId" :placeholder="$t('请输入设备ID')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('校验标准')">
              <a-row :gutter="16" style="border: 1px dashed #08092D">
                <a-col :span="12">
                  <span><span>{{ $t('酸碱度上限：') }}</span>{{model.remark.ph_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('酸碱度下限：') }}</span>{{model.remark.ph_down}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('温度上限：') }}</span>{{model.remark.temp_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('温度下限：') }}</span>{{model.remark.temp_down}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('浊度上限：') }}</span>{{model.remark.ss_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('浊度下限：') }}</span>{{model.remark.ss_down}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('余氯上限：') }}</span>{{model.remark.fcl_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('余氯下限：') }}</span>{{model.remark.fcl_down}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('溶解氧上限：') }}</span>{{model.remark.doo_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('溶解氧下限：') }}</span>{{model.remark.doo_down}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('氧化还原上限：') }}</span>{{model.remark.orp_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('氧化还原下限：') }}</span>{{model.remark.orp_down}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('电导率上限：') }}</span>{{model.remark.ec_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('电导率下限：') }}</span>{{model.remark.ec_down}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('氨氮上限：') }}</span>{{model.remark.nh3n_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('氨氮下限：') }}</span>{{model.remark.nh3n_down}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('化学耗氧量上限：') }}</span>{{model.remark.chemo_up}}</span>
                </a-col>
                <a-col :span="12">
                  <span><span>{{ $t('化学耗氧量下限：') }}</span>{{model.remark.chemo_down}}</span>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'WQDataRecordForm',
    components: {
      JFormContainer
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {remark: {}},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/wq/wQDataRecord/add",
          edit: "/wq/wQDataRecord/edit"
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        console.log(this.model!=='{}')
        if(this.model!=='{}') {
          console.log("model不为空")
          this.model.remark = JSON.parse(this.model.remark)
        }
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      }
    }
  }
</script>